import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from '@/lib/toast';
import { api } from '@/lib/api';
import { errToToast } from '@/lib/humanizeApiError';
import { useAuthStore } from '@/stores/authStore';
import { useDataStore } from '@/stores/dataStore';
import { Switch } from '@/components/ui/Switch';

/** Author-owned team privacy, persisted by the authenticated me route. */
export function ShowTeamInDmsToggle() {
  const { t } = useTranslation();
  const me = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const updateCachedUser = useDataStore((s) => s.updateCachedUser);
  const [saving, setSaving] = useState(false);

  // Default ON — matches the server default and the historical behaviour.
  const checked = me?.showTeamInDms ?? true;

  async function change(next: boolean) {
    if (saving) return;
    setSaving(true);
    try {
      const updated = await api.updateMe({ showTeamInDms: next });
      setUser(updated);
      updateCachedUser(updated);
    } catch (err) {
      toast.error(...errToToast(err, t('prof.teamInDms.saveFailed')));
    } finally {
      setSaving(false);
    }
  }

  return (
    <Switch
      checked={checked}
      onChange={(next) => void change(next)}
      disabled={saving || !me}
      label={t('prof.teamInDms.label')}
    />
  );
}
